import React, { useState } from 'react';
import {
  Box,
  TextField,
  Button,
  Grid,
  Switch,
  FormControlLabel,
  Typography
} from '@mui/material';
import { authenticationService } from 'src/services';
import { post } from 'src/services/httpClient.service';
import { useSnackbar } from 'src/components/snackbar/useSnackbar';

interface AddCountryProps {
  handleClose: () => void;
  fetchCountries: () => void;
}

const AddCountry: React.FC<AddCountryProps> = ({
  handleClose,
  fetchCountries
}) => {
  const { vendorId } = authenticationService.getVendorFranchiseIds();
  const { showSnackbar } = useSnackbar();
  const APIURL = process.env.REACT_APP_BASE_API_URL;

  const [loading, setLoading] = useState(false);

  const [form, setForm] = useState({
    name: '',
    shortCode: '',
    phoneCode: '',
    isActive: true,
    vendorId: vendorId
  });

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleSwitchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setForm(prev => ({ ...prev, isActive: e.target.checked }));
  };

  const handleSubmit = async () => {
    if (!form.name) {
      showSnackbar('Country name is required', 'warning');
      return;
    }

    setLoading(true);

    try {
      const payload = {
        name: form.name,
        shortCode: form.shortCode || null,
        phoneCode: form.phoneCode || null,
        isActive: form.isActive,
        vendorId: form.vendorId
      };

      const res = await post(
        `${APIURL}/api/miscellaneous/country`,
        payload
      );
      console.log("res",res)
      showSnackbar('Country added successfully', 'success');
      fetchCountries();
      handleClose();
    } catch (error) {
      console.error('Failed to add country', error);
      showSnackbar('Failed to add country', 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box p={3}>
      <Typography variant="h6" mb={2}>
        Add Country
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            fullWidth
            required
            label="Country Name"
            name="name"
            value={form.name}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            fullWidth
            label="Short Code"
            name="shortCode"
            value={form.shortCode}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            fullWidth
            label="Phone Code"
            name="phoneCode"
            value={form.phoneCode}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Switch
                checked={form.isActive}
                onChange={handleSwitchChange}
              />
            }
            label="Is Active"
          />
        </Grid>

        <Grid item xs={12} display="flex" justifyContent="flex-end" gap={2}>
          <Button
            variant="outlined"
            onClick={handleClose}
            disabled={loading}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleSubmit}
            disabled={loading}
          >
            Save
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default AddCountry;
